module.exports = __webpack_public_path__ + "static/media/pending_report.42c2229b.svg";